import styled from 'styled-components';

export const A = styled.a`
  cursor: pointer;
  display: inline-flex;
  text-decoration: none;
`;
